






































import { Dialog, Button } from 'element-ui'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Uploader from '@/utils/uploads'
import { VueCropper } from 'vue-cropper'

@Component({
  components: {
    VueCropper,
    Dialog,
    Button,
  },
})
export default class EditorCropper extends Vue {
  @Prop({ type: Object, default: null })
  CropperData!: Record<string, any>

  Previews = {}
  loading: Boolean = false

  // 取消
  onCropperCancel() {
    this.loading = false
    // @ts-ignore
    this.$refs.cropper.refresh()
    this.$emit('finsh', 'fail')
  }
  // 确认裁切
  onCropperSure() {
    // @ts-ignore
    this.$refs.cropper.getCropBlob((data: any) => {
      if (this.CropperData.userCropper) {
        //用户修改信息裁剪
        this.$emit('finsh', data)
      } else {
        const newFile = new window.File([data], this.CropperData.file.name, {
          type: this.CropperData.file.type,
        })
        this.cropperFinsh(newFile) //裁剪后的数据
      }
    })
  }
  // 完成
  cropperFinsh(data: any) {
    this.loading = true
    if (data) {
      this.startUpload([data])
    }
  }

  startUpload(files: Array<any>) {
    const uploader: any = new Uploader({
      file: files,
    })
    uploader.on('error', (err: any) => {
      this.loading = false
      this.$emit('finsh', 'fail')
      // @ts-ignore
      this.$refs.cropper.refresh()
      this.$notify.error({
        title: '错误',
        message: err,
      })
    })
    uploader.on('success', (info: any) => {
      // @ts-ignore
      this.$refs.cropper.refresh()
      this.loading = false
      this.$emit('finsh', info.url, info.key, info.file)
    })
  }

  realTime(data: any) {
    this.Previews = data
  }
}
